// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import router from './router'
import global  from './assets/js/common/common.js'
import store from './store'
//element组件引用
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
/*import stockInit from 'highcharts/modules/stock'
import Wordcloud from 'highcharts/modules/wordcloud';
import Highcharts from 'highcharts'
import HighStock from 'highcharts/highstock'
import HighchartsNoData from 'highcharts/modules/no-data-to-display'
import HighchartsVue from 'highcharts-vue'*/
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import moment from 'moment'
Vue.prototype.$moment = moment;
//百度地图
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  //百度地图密钥
  ak: '6PYkS1eDz5pMnyfO0jvBNE0F'
})
/*HighchartsNoData(Highcharts);
Wordcloud(Highcharts)
stockInit(Highcharts)*/
//导出EXCEL vue-json-excel
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)
/*Vue.use(HighchartsVue)*/
import infiniteScroll from 'vue-infinite-scroll'
import jquery from "jquery";
Vue.prototype.$ = jquery;
Vue.use(infiniteScroll)
Vue.prototype.$echarts = echarts
//导出EXCEL pikaz-excel-js
 import {ExcelExport} from 'pikaz-excel-js'
Vue.component('ExcelExport', ExcelExport)
import VueI18n from 'vue-i18n'

import ElementLocale from 'element-ui/lib/locale'
Vue.use(VueI18n);

import jaLocale from 'element-ui/lib/locale/lang/ja'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

const messages = {
  ja: {
    message: 'hello',
    ...jaLocale // 或者用 Object.assign({ message: 'hello' }, enLocale)
  },
  zh: {
    message: 'hello',
    ...zhLocale
  }
}
// const i18n = new VueI18n({
//   locale: 'ja', // 将要切换的语言，可以通过url拼的参数获取，用户行为select选择获取，本地manifest配置获取等，根据场景动态获取
//   messages,
//   silentTranslationWarn: true,
// });

const i18n = new VueI18n({
  locale: (localStorage.getItem("LoginLanguage") == null) ? 'chs' : localStorage.getItem("LoginLanguage"), // 将要切换的语言，可以通过url拼的参数获取，用户行为select选择获取，本地manifest配置获取等，根据场景动态获取
  messages: {
    'chs': require('../static/languages/chs.json'), // 本地资源文件，我这里配2个语言，中文&英文，src下根据个人情况放置
    'en': require('../static/languages/en.json'),
    'ja': require('../static/languages/ja.json')
  },
  silentTranslationWarn: true,
});
ElementLocale.i18n((key, value) => i18n.t(key, value))


Vue.config.productionTip = false

import dialogDrag from '@/utils/dialogDrag'
import {
	parseTime,
	addDateRange
} from "@/utils/ruoyi";
import RightToolbar from "@/components/RightToolbar"
import Pagination from "@/components/Pagination";
import DictTag from '@/components/DictTag'
import DictData from '@/components/DictData'
import '@/assets/styles/index.css' // global css
import plugins from './plugins' // plugins

Vue.prototype.parseTime = parseTime
Vue.prototype.addDateRange = addDateRange
Vue.component('RightToolbar', RightToolbar)
Vue.component('Pagination', Pagination)
Vue.component('DictTag', DictTag)
Vue.use(plugins)
DictData.install()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})

const loadedLanguages = []
//1.chs   2.en   3.ja
function setI18nLanguage (lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}
export function loadLanguageAsync (lang) {
 /* console.log(loadedLanguages.includes(lang))
  if (loadedLanguages.includes(lang)) {
    if (i18n.locale !== lang) setI18nLanguage(lang)
    return Promise.resolve()
  }*/
  return axios.get(store.getters.getPostUrl+`mes/i18n/i18n?type=3`).then(response => {
    let msgs = response.data;
    localStorage.setItem("i18nData", JSON.stringify(msgs.data));
    // if (lang=="chs"){
    //   loadedLanguages.push('chs')
    //   i18n.setLocaleMessage('chs',  Object.assign(msgs.data.chs, jaLocale))
    //   setI18nLanguage('chs')
    // }
    // if (lang=="ja"){
    //   loadedLanguages.push('ja')
    //   i18n.setLocaleMessage('ja',Object.assign(msgs.data.ja, jaLocale))
    //   setI18nLanguage('ja')
    // }
    // if (lang=="en"){
    //   loadedLanguages.push('en')
    //   i18n.setLocaleMessage('en', msgs.data.en)
    //   setI18nLanguage('en')
    // }
    // Vue.prototype.$("#loader-wrapper").hide();
    setLanguage(lang)
  }).catch((response) => {
    console.log(response)
  })
}

export function setLanguage(lang) {
  let languageData = JSON.parse(localStorage.getItem("i18nData"))
  // console.log(loadedLanguages)
  if (lang=="chs"){
    // loadedLanguages.push('chs')
    i18n.setLocaleMessage('chs',  Object.assign(languageData.chs, zhLocale))
    setI18nLanguage('chs')
  }
  if (lang=="ja"){
    // loadedLanguages.push('ja')
    i18n.setLocaleMessage('ja',Object.assign(languageData.ja, jaLocale))
    setI18nLanguage('ja')
  }
  if (lang=="en"){
    // loadedLanguages.push('en')
    i18n.setLocaleMessage('en', languageData.en)
    setI18nLanguage('en')
  }
  Vue.prototype.$("#loader-wrapper").hide();
}

// router.js
/*router.beforeEach((to, from, next) => {
  const lang = store.getters.getLanguageName;
  console.log(lang)
  if (lang=="1"){
    loadLanguageAsync('chs').then(() => next())
  }
  if (lang=="2"){
    loadLanguageAsync('ja').then(() => next())
  }
  if (lang=="3"){
    loadLanguageAsync('en').then(() => next())
  }
})*/

// 路由守卫
router.beforeEach((to, from, next) => {
  console.log('路由跳转:', to.path, '需要认证:', to.meta.requiresAuth)
  
  // 检查当前路由是否需要认证
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isPublic = to.matched.some(record => record.meta.isPublic)
  
  console.log('requiresAuth:', requiresAuth, 'isPublic:', isPublic)
  
  // 如果是公共页面或明确不需要认证，直接放行
  if (isPublic || requiresAuth === false) {
    console.log('访问公共页面，直接放行')
    next()
    return
  }
  
  // 检查用户是否已登录
  const isLoggedIn = store.getters.getSessionId || localStorage.getItem('userToken')
  console.log('用户登录状态:', isLoggedIn)
  
  if (requiresAuth && !isLoggedIn) {
    console.log('需要登录，跳转到登录页')
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    console.log('已登录或不需要认证，放行')
    next()
  }
})

// 可选的全局后置钩子
router.afterEach((to, from) => {
  console.log('成功导航到:', to.path)
})


// WEBPACK FOOTER //
// ./src/main.js